<template>
    <div class="container-item-wrapper">
        <CoverPanel
            :noCoverIcon="noCoverIcon"
            :imageUrl="data.cardImage"
            :operateIcons="operateIcons"
            :viewIcon="viewIcon"
            @uploadCover="uploadCover"
            @operatorSelect="operatorSelect"
        />
        <IconInput :placeholder="inputDescLabel" class="container-input" :initValue="data.name" @inputChange="descChange" />
        <!--屏蔽红点，待C端支持之后开放-->
        <HotPointPanel :data="hotPointData" @redSwitch="redSwitch" @hotSwitch="hotSwitch" @endDateChange="hotDateChange" v-show="false" />
        <div class="relation-question-wrapper">
            <div class="c-relation-question">
                <span class="relation-question" @mouseover="mouseOnQuestion" @mouseout="mouseOutQuestion" @click="questionClick">
                    {{ data.question || defaultQuestion }}
                </span>
            </div>
            <QuestionSimpleView
                class="question-view"
                v-if="showSimple"
                :content="simpleContent"
                @onview="mouseOnQuestion"
                @outview="mouseOutQuestion"
            />
            <QuestionSearch
                class="question-search"
                :questionId="data.questionId"
                :question="data.question"
                v-if="isShowSearch"
                @questionSelected="questionSelected"
                :hideSelect="true"
            />
        </div>
        <TransferIcon class="opr-transfer" @transfer="tranferItem" />
        <DeleteIcon class="opr-delete" @iconClick="deleteItem" />
    </div>
</template>

<script>
import CoverPanel from "../CoverPanel";
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import HotPointPanel from "../HotPointPanel";
import QuestionSimpleView from "../../options/QuestionSimpleView";
import QuestionSearch from "@/views/zhiji/components/questionSearch/QuestionSearch";
import TransferIcon from "@/views/zhiji/bComponents/icons/TransferIcon";
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon";

export default {
    name: "ContainerItem",
    props: ["data", "parentUId"],
    components: {
        CoverPanel,
        IconInput,
        HotPointPanel,
        QuestionSearch,
        QuestionSimpleView,
        TransferIcon,
        DeleteIcon
    },
    data() {
        return {
            isShowSimple: false,
            isShowSearch: false,
            simpleContent: "",
            viewIcon: {
                position: "-172px -74px",
                isShowIcon: true
            }
        };
    },
    computed: {
        showSimple() {
            return this.isShowSimple && !this.isShowSearch && !!this.simpleContent;
        },
        hotPointData() {
            return {
                redState: this.data.redState,
                hotItem: this.data.hotItem,
                endTime: this.data.redHotEndTime
            };
        },
        inputDescLabel() {
            return this.$t("zhiji.answer.inputDesc");
        },
        defaultQuestion() {
            return this.$t("zhiji.answer.textWidget.linkQuestion");
        },
        noCoverIcon() {
            return {
                position: "-145px -50px",
                label: this.$t("zhiji.answer.uploadIcon")
            };
        },
        operateIcons() {
            return [
                {
                    type: "update",
                    position: "-38px -77px",
                    name: this.$t("zhiji.answer.replaceIcon")
                }
            ];
        }
    },
    methods: {
        mouseOnQuestion() {
            this.simpleTimeout && clearTimeout(this.simpleTimeout);
            this.simpleTimeout = setTimeout(() => {
                this.isShowSimple = true;

                this.data.questionId &&
                    this.zhiji
                        .requestByServiceName("queryQuesSimpleById", {
                            questionId: this.data.questionId
                        })
                        .then(resp => {
                            this.simpleContent = resp.answerText;
                        });
            }, 500);
        },
        tranferItem(event) {
            this.zhiji.dragStart(event, "h-list-item", "h", newIdx => {
                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: "tranferContentItem",
                    widget: {
                        uId: this.parentUId,
                        item: {
                            newIdx: newIdx,
                            uId: this.data.uId
                        }
                    }
                });
            });
        },
        deleteItem() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: this.$t("zhiji.answer.delCardTips"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.commit("zhiji/editQsUpdateAnswer", {
                            type: "deleteContentItem",
                            widget: {
                                uId: this.parentUId,
                                item: {
                                    uId: this.data.uId
                                }
                            }
                        });
                    }
                }
            });
        },
        descChange(newVal) {
            this.commitUpdate({
                name: newVal
            });
        },
        redSwitch(redState) {
            this.commitUpdate({
                redState: redState
            });
        },
        hotSwitch(hotItem) {
            this.commitUpdate({
                hotItem: hotItem
            });
        },
        hotDateChange(dateStr) {
            this.commitUpdate({
                redHotEndTime: dateStr
            });
        },
        uploadCover() {
            this.uploadImage(imageUrl => {
                this.commitUpdate({
                    cardImage: imageUrl
                });
            });
        },
        operatorSelect(type) {
            if (type == "update") {
                this.uploadImage(imageUrl => {
                    this.commitUpdate({
                        cardImage: imageUrl
                    });
                });
            }
        },
        mouseOutQuestion() {
            this.simpleTimeout && clearTimeout(this.simpleTimeout);
            this.simpleTimeout = setTimeout(() => {
                this.isShowSimple = false;
            }, 500);
        },
        questionClick() {
            this.isShowSearch = !this.isShowSearch;
        },
        questionSelected(data) {
            this.isShowSearch = false;
            let relationQuestion = {
                question: data.question,
                questionId: data.questionId,
                uId: this.data.uId
            };
            this.commitUpdate(relationQuestion);
        },
        windowClick(event) {
            if (this.isShowSearch && this.zhiji.isClickOuter(event, "container-item-wrapper")) {
                this.isShowSearch = false;
            }
        },
        commitUpdate(updateData) {
            updateData.uId = this.data.uId;
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateContentItem",
                widget: {
                    uId: this.parentUId,
                    item: updateData
                }
            });
        },
        uploadImage(cb) {
            this.$store.commit("zhiji/showModal", {
                type: "ImageClipModal",
                data: {
                    openFile: openFile => {
                        this.openFile = openFile;
                    },
                    confirm: url => {
                        cb && cb(url);
                    },
                    cancel: () => {
                        this.openFile = null;
                    },
                    needClip: true,
                    aspectRatio: 1 / 1
                }
            });

            // 打开组件时弹出文件选择，只有在isTrusted事件里面可以触发, HACK
            setTimeout(() => {
                this.openFile();
                this.openFile = null;
            }, 500);
        }
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    }
};
</script>

<style lang="scss" scoped>
.container-item-wrapper {
    position: relative;
    background: #fff;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    margin-right: 16px;
    font-size: 12px;
    width: 200px;
    flex-shrink: 0;

    .container-input {
        width: 200px;
    }
    .relation-question-wrapper {
        border-top: 1px solid #d8e4f0;
        position: relative;
        box-sizing: border-box;
    }

    .opr-transfer {
        display: none;
        z-index: 1;
        top: -21px;
        left: -2px;
        position: absolute;
    }

    .opr-delete {
        display: none;
        z-index: 1;
        right: -9px;
        top: -9px;
        position: absolute;
    }

    &:hover {
        .opr-transfer {
            display: inline-flex;
        }

        .opr-delete {
            display: inline-block;
        }
    }
    .container-item-icon {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 200px;
        height: 200px;
        background: #fafbfd;
        border-radius: 4px 4px 0px 0px;
        cursor: pointer;

        &:hover {
            color: #2ec2ff;

            .item-icon {
                background-position-y: -74px !important;
            }
        }
    }

    .c-relation-question {
        padding: 12px 0;
        text-align: center;

        .relation-question {
            display: block;
            background: #ffffff;
            border: 1px solid #d8e4f0;
            border-radius: 20px;
            width: 175px;
            height: 32px;
            margin: 0 auto;
            padding: 0 8px;
            box-sizing: border-box;
            line-height: 32px;
            text-align: center;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:hover {
                color: #2ec2ff;
            }
        }
    }
    .question-search {
        position: absolute;
        z-index: 1;
        bottom: -12px;
    }

    .question-view {
        top: 35px;
        left: -40px;
    }
}
</style>
